import { useQuery } from "@tanstack/react-query";
import { commercialsApi } from "../api/commercials";
import { ChangeEvent, useState } from "react";

export const usePayments = (projectId: string | undefined) => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);

    const [searchDraft, setSearchDraft] = useState<string>('');
    const [searchKey, setSearchKey] = useState<string>('');

    const changePage = (newPage: number) => {
        setPage(newPage);
    };

    const changeRowsPerPage = (newLimit: number) => {
        setPage(1);
        setLimit(newLimit);
    };

    const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchDraft(e.target.value);
    };

    const handleClear = () => {
        setSearchDraft('');
        setSearchKey('');
    };

    const handleSearch = () => {
        setSearchKey(searchDraft);
    };

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["project-payments", projectId, page, limit, searchKey],
        queryFn: () => commercialsApi.fetchPayments({ projectId, page, limit, searchKey }),
    });

    return {
        data: data?.data?.rows, pagination: data?.data?.pagination, isLoading, isError, error, changePage, changeRowsPerPage, searchDraft, handleChangeSearch, handleClear, handleSearch
    };

};